import React from "react";
import HeroSlider from "../components/HeroSlider";

import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";

import Footer from "../components/Footer";
import AllServiceRegions from "../components/AllServiceRegions";


const AllServiceRegionsPage = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <AllServiceRegions/>
      <ServicesGrid />
      <BlogList/>
      
      <Footer/>
     
    </div>
     </>
  );
};

export default AllServiceRegionsPage;
